








































































































import { walletStore } from '@/stores/wallet-store'
import { Observer } from 'mobx-vue'
import { Component, Inject, Vue } from 'vue-property-decorator'
import { SbStakingViewModel } from '../viewmodel/sb-staking-viewmodel'

@Observer
@Component({
  components: {
    ConnectButton: () => import('@/components/ConnectButton.vue')
  }
})
export default class SBStaking extends Vue {
  @Inject() vm!: SbStakingViewModel
  walletStore = walletStore

  get displayFlex() {
    return this.$vuetify.breakpoint.mdAndUp ? '' : 'd-flex align-center justify-space-between'
  }
}
